// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutUsContainer{
    width: 85%;
    margin: auto;
    margin-bottom: 20%;
}
.aboutUsImgDiv{
    margin: 5%;
}
.aboutUsImg { 
    float: right; 
    margin: 5px; 
    margin-left: 5%;
    width: 55%;
    margin-right: 0;
  } 

  .aboutUsContent { 
    text-align: justify; 
    font-size: 16px; 
  } 
  .aboutUsHeadig{
    /* color: #174f5d; */
    color: #17213A;
    text-align: center;
    margin-top: 4%;
    position: relative;
  }
 .returnBackArrow{
    position: absolute;
    left: 0%;
    bottom: 0%;
    cursor: pointer;
 }
 .tokensBtn{
  background-color: transparent;
  border: none;
  position: absolute;
  right: 12%;
  top: 3.5%;
  z-index: 45;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/AboutUs.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;CACD;IACG,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;CAClB;CACA;EACC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,eAAe;AACjB","sourcesContent":[".aboutUsContainer{\n    width: 85%;\n    margin: auto;\n    margin-bottom: 20%;\n}\n.aboutUsImgDiv{\n    margin: 5%;\n}\n.aboutUsImg { \n    float: right; \n    margin: 5px; \n    margin-left: 5%;\n    width: 55%;\n    margin-right: 0;\n  } \n\n  .aboutUsContent { \n    text-align: justify; \n    font-size: 16px; \n  } \n  .aboutUsHeadig{\n    /* color: #174f5d; */\n    color: #17213A;\n    text-align: center;\n    margin-top: 4%;\n    position: relative;\n  }\n .returnBackArrow{\n    position: absolute;\n    left: 0%;\n    bottom: 0%;\n    cursor: pointer;\n }\n .tokensBtn{\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  right: 12%;\n  top: 3.5%;\n  z-index: 45;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
